import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Tile from '../../components/Tile';
import { FaGraduationCap, FaFileAlt, FaFileContract, FaCalendarTimes } from 'react-icons/fa';

const tiles = [
  {
    title: 'Zmiana praktyk',
    description: 'Wszystko o zmianach praktyk zawodowych.',
    icon: <FaGraduationCap />,
    to: '/internships',
  },
  {
    title: 'Wzory dokumentów',
    description: 'Przydatne szablony dokumentów do pobrania.',
    icon: <FaFileAlt />,
    gradient: 'pink',
    to: '/documents',
  },
  {
    title: 'Tryby rozwiązania umów',
    description: 'Jak prawidłowo rozwiązać umowę o pracę?',
    icon: <FaFileContract />,
    gradient: 'purple',
    to: '/termination-modes',
  },
  {
    title: 'Okresy wypowiedzenia',
    description: 'Jakie są terminy wypowiedzenia umowy?',
    icon: <FaCalendarTimes />,
    gradient: 'green',
    to: '/notice-periods',
  },
];

const Changes = () => {
  const navigate = useNavigate();
  const handleTileClick = (to) => {
    navigate(to);
  };

  return (
    <Container className="py-4">
      <h1 className="mb-4 fw-bold text-center">Więcej o zmianach</h1>
      <Row className="g-4 justify-content-center">
        {tiles.map((tile, idx) => (
          <Col key={tile.title} xs={12} sm={6} md={4} lg={3}>
            <Tile {...tile} onClick={() => handleTileClick(tile.to)} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Changes;
